(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["paw-travel-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('paw-travel-picker')) {
  customElements.define('paw-travel-picker', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const form = this.closest('form');
      if (!form) return;
      const signal = this.abort.signal;
      const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      const selects = [...this.querySelectorAll('select')];
      const confirmation = this.querySelector('input[type="checkbox"]');
      const id = form.querySelector('[name="id"]');
      const error = this.querySelector('[data-error-message]');

      const dialog = this.querySelector('.paw-travel-color-menu');
      const title = dialog.querySelector('[data-color-title]');
      const baseTitle = title.textContent;
      const choices = [...dialog.querySelectorAll('[data-color-choice]')];
      this.querySelectorAll('.paw-travel-color-trigger').forEach(trigger => trigger.remove());
      const triggers = new Map();
      let activeColor = null;
      const paintTrigger = select => {
        const trigger = triggers.get(select);
        const choice = choices.find(button => button.dataset.value === select.value);
        trigger.replaceChildren();
        const photo = choice?.querySelector('img');
        if (photo) {
          const thumb = photo.cloneNode(true);
          thumb.alt = '';
          trigger.append(thumb);
        }
        const text = document.createElement('span');
        text.textContent = select.selectedOptions[0]?.textContent || '';
        trigger.append(text);
        trigger.setAttribute('aria-label', select.closest('fieldset').querySelector('legend').textContent + ' — ' + text.textContent);
      };
      const openColors = select => {
        activeColor = select;
        title.textContent = baseTitle + ' — ' + select.closest('fieldset').querySelector('legend').textContent;
        choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === select.value)));
        if (!dialog.open) dialog.showModal();
        triggers.get(select).setAttribute('aria-expanded', 'true');
        (choices.find(button => button.dataset.value === select.value) || choices[0]).focus();
      };
      this.querySelectorAll('select[data-color]').forEach(select => {
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'paw-travel-color-trigger';
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', event => {
          event.preventDefault();
          openColors(select);
        }, {signal});
        select.after(trigger);
        triggers.set(select, trigger);
        select.classList.add('paw-travel-color-native');
        select.tabIndex = -1;
        select.addEventListener('focus', () => openColors(select), {signal});
        select.addEventListener('invalid', event => event.preventDefault(), {signal});
        paintTrigger(select);
      });
      choices.forEach(choice => choice.addEventListener('click', () => {
        if (!activeColor) return;
        activeColor.value = choice.dataset.value;
        paintTrigger(activeColor);
        activeColor.dispatchEvent(new Event('change', {bubbles:true}));
        dialog.close();
      }, {signal}));
      dialog.querySelector('[data-color-close]').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, {signal});
      dialog.addEventListener('close', () => {
        if (!activeColor) return;
        triggers.get(activeColor).setAttribute('aria-expanded', 'false');
        triggers.get(activeColor).focus();
      }, {signal});
      dialog.addEventListener('keydown', event => {
        if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const index = choices.indexOf(document.activeElement);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + choices.length) % choices.length;
        choices[next].focus();
      }, {signal});

      const resolve = () => {
        const values = selects.map(select => select.value);
        const variant = values.every(Boolean) ? variants.find(item =>
          item.options[0] === values[0] + ' / ' + values[1] &&
          item.options[1] === values[2] + ' / ' + values[3]) : null;
        id.value = variant?.id || '';
        id.disabled = !variant;
        return variant;
      };
      this.addEventListener('change', event => {
        if (event.target.tagName === 'SELECT') confirmation.checked = false;
        error.hidden = true;
        resolve();
      }, {signal});
      const guard = event => {
        if (!resolve() || !form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          error.textContent = this.dataset.error;
          error.hidden = false;
          const missing = selects.find(select => !select.value);
          if (missing && triggers.has(missing)) openColors(missing);
          else form.reportValidity();
        }
      };
      form.addEventListener('submit', guard, {capture:true,signal});
      form.addEventListener('click', event => {
        if (event.target.closest('button[type="submit"],input[type="submit"]')) guard(event);
      }, {capture:true,signal});
      resolve();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
